export const getCurrentMonth = (language = 'en') => {
	const month = new Date().getMonth() + 1;
	const monthFullName = new Date().toLocaleString(language, { month: 'long' });
	const year = new Date().getFullYear();
	return {
		monthYear: `${formatMonth(month).number}-${year}`,
		name: monthFullName,
	}
}

export const formatMonth = (month, language = 'en') => {
	const formattedMonth = {};

	if (typeof month === 'number') {
		if (month < 10) {
			formattedMonth.number = `0${month}`;
			return formattedMonth;
		}
		
		formattedMonth.number = month.toString();
		return formattedMonth;
	}

	const numericMonth = new Date(month).toLocaleString(language, { 
		month: "numeric",
	});

	const shortMonth = new Date(month).toLocaleString(language, { 
		month: "short",
	});

	const fullMonth = new Date(month).toLocaleString(language, { 
		month: "long",
	});

	formattedMonth.short = shortMonth;
	formattedMonth.full = fullMonth;
	formattedMonth.number = numericMonth;
	return formattedMonth;
}

export const formatWeekDay = (language = 'en', date) => {
	const shortDay = new Date(date).toLocaleString(language, { 
		weekday: "short",
	});

	return {
		short: shortDay,
	}
}